export function getLottoBallColorHex(num: number): string {
  if (num >= 1 && num <= 10) return '#fbc400'
  if (num >= 11 && num <= 20) return '#69c8f2'
  if (num >= 21 && num <= 30) return '#ff7272'
  if (num >= 31 && num <= 40) return '#aaaaaa'
  return '#b0d840'
}

export function getReadableTextColor(bgHex: string): string {
  const hex = bgHex.replace('#', '')
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255
  return luminance > 0.6 ? '#000000' : '#ffffff'
}

